import React from 'react';

interface EventMarkerSvgProps {
  backgroundColor: string;
}

/**
 * Event marker with SVG - rectangle with "EVENT" text and triangle with full white border
 * Ported from ui/src/components/markers/EventMarkerSvg.tsx
 */
export const EventMarkerSvg: React.FC<EventMarkerSvgProps> = ({ backgroundColor }) => {
  return (
    <div style={styles.eventMarkerContainer}>
      <div style={styles.markerInnerContainer}>
        <div style={styles.combinedContainer}>
          <svg width="46" height="40" viewBox="0 0 46 40">
            {/* White border - outer shape */}
            <path
              d="M 6,0 L 40,0 Q 46,0 46,6 L 46,26 Q 46,32 40,32 L 28,32 L 23,38 L 18,32 L 6,32 Q 0,32 0,26 L 0,6 Q 0,0 6,0 Z"
              fill="white"
            />
            {/* Colored fill - inner shape */}
            <path
              d="M 6,2 L 40,2 Q 44,2 44,6 L 44,26 Q 44,30 40,30 L 27,30 L 23,36 L 19,30 L 6,30 Q 2,30 2,26 L 2,6 Q 2,2 6,2 Z"
              fill={backgroundColor}
            />
          </svg>
          <div style={styles.textOverlay}>
            <span style={styles.eventText}>EVENT</span>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  eventMarkerContainer: {
    display: 'flex' as const,
    alignItems: 'center',
    backgroundColor: 'transparent',
    height: 54,
    justifyContent: 'center',
    width: 50,
  },
  eventText: {
    color: 'white',
    fontSize: 10,
    fontWeight: 'bold' as const,
  },
  markerInnerContainer: {
    display: 'flex' as const,
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative' as const,
  },
  combinedContainer: {
    display: 'flex' as const,
    height: 40,
    width: 46,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative' as const,
  },
  textOverlay: {
    position: 'absolute' as const,
    display: 'flex' as const,
    justifyContent: 'center',
    alignItems: 'center',
    top: 0,
    left: 0,
    right: 0,
    bottom: 8,
  },
};
